import { render } from "./StatusTabs.vue?vue&type=template&id=0ebd9e7c&scoped=true"
import script from "./StatusTabs.vue?vue&type=script&lang=js"
export * from "./StatusTabs.vue?vue&type=script&lang=js"

import "./StatusTabs.vue?vue&type=style&index=0&id=0ebd9e7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebd9e7c"]])

export default __exports__